import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Select } from "ui";

import {
  LocationBlockProps,
  FilterFormValues
} from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

export const LocationBlock = ({
  locations,
  isLocationsLoading
}: LocationBlockProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>{t("Location")}</h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name="deliveryZoneId"
          render={({ field: { onChange, value } }) => (
            <Select
              value={value}
              placeholder={t("Choose Location")}
              onChange={onChange}
              options={locations}
              isOptionsLoading={isLocationsLoading}
            />
          )}
        />
      </div>
    </div>
  );
};
